<template>
  <div class="page">
    <div id="main-box">
      <!-- <div id="btn-box"> -->
      <div>
        <el-form label-width="100px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="关键字">
                <el-input v-model="queryForm.Keyword" placeholder="请输入角色名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item>
                <div class="flex">
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button @click="empty">重置</el-button>
                  <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- </div> -->

      <el-table :data="roleList" highlight-current-row v-loading="tableLoading" @current-change="selectCurrentRow"
        style="width: 100%" border>
        <el-table-column prop="name" label="角色英文名" min-width="200" align="center"></el-table-column>
        <el-table-column prop="displayName" label="角色名" min-width="200" align="center"></el-table-column>
        <el-table-column prop="description" label="描述" min-width="500" align="center"></el-table-column>
      </el-table>
      <el-pagination layout="total, sizes, prev, pager, next, jumper" class="pagination" :total="total"
        :current-page="queryForm.pageIndex" :pageSize="queryForm.pageSize" @current-change="handleCurrentChange"
        @size-change="handleSizeChange"></el-pagination>

      <el-dialog :title="isEdit ? '编辑' : '新增'" :visible.sync="roleFormVisible" v-if="roleFormVisible"
        v-model="roleFormVisible" :close-on-click-modal="false">
        <el-form :model="roleForm" label-width="120px" :rules="roleFormRules" ref="roleForm">
          <el-form-item label="角色英文名" prop="name">
            <el-input v-model="roleForm.name" auto-complete="off" placeholder="请输入角色英文名"></el-input>
          </el-form-item>
          <el-form-item label="角色名" prop="displayName">
            <el-input v-model="roleForm.displayName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input v-model="roleForm.description" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="roleFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="submitRole" :loading="submitLoading">提交</el-button>
        </div>
      </el-dialog>

      <el-dialog title="分配权限" :visible.sync="setPermissionsDialog" v-if="setPermissionsDialog"
        v-model="setPermissionsDialog" :close-on-click-modal="false">
        <el-tree :data="permissionsList" show-checkbox node-key="id" ref="tree" highlight-current :props="defaultProps">
        </el-tree>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="setPermissionsDialog = false">取消</el-button>
          <el-button type="primary" @click.native="submitPermissions" :loading="submitLoading">提交</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  GetAllRole,
  CreateRole,
  GetRoleDetail,
  UpdateRole,
  DeleteRole,
  GetMenuTree,
  GetPermissions,
  SetPermissions
} from "../../api/api";
import toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
export default {
  components: { toolbar },
  data() {
    return {
      buttonList_toolBar: [],

      roleList: [],
      tableLoading: false,
      currentRow: null,
      total: 0,
      queryForm: {
        Keyword: null,
        pageIndex: 1,
        pageSize: 10
      },

      roleFormVisible: false,
      isEdit: false,
      roleForm: {
        name: null,
        displayName: null,
        normalizedName: null,
        description: null,
        grantedPermissions: []
      },
      roleFormRules: {
        name: [
          { required: true, message: '请输入角色英文名', trigger: 'blur' },
          { message: '请输入角色英文名', trigger: ['blur', 'change'] }
        ],
        displayName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
          { message: '请输入角色名称', trigger: ['blur', 'change'] }
        ]
      },
      submitLoading: false,

      setPermissionsDialog: false,
      permissionsList: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    };
  },
  mounted() {
    this.getRoleList();
    this.getpermissionsList();
    this.renderButton();
  },
  methods: {
    renderButton() {
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      var buttonList = getButtonList(this.$route.path, routers);
      this.buttonList_toolBar = buttonList.filter((item) => {
        return item.buttonShow == 10 && item.isVisible;
      });
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    getRoleList() {
      this.tableLoading = true;
      let params = {
        Keyword: this.queryForm.Keyword,
        SkipCount: (this.queryForm.pageIndex - 1) * 10,
        MaxResultCount: this.queryForm.pageSize
      }
      let that = this;
      GetAllRole(params).then((res) => {
        that.tableLoading = false;
        that.total = res.data.result.totalCount;
        that.roleList = res.data.result.items;
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    handleCurrentChange(val) {
      this.queryForm.pageIndex = val;
      this.getRoleList();
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.getRoleList();
    },
    search() {
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getRoleList();
    },
    empty() {
      this.queryForm.Keyword = null;
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getRoleList();
    },
    addRole() {
      this.roleFormVisible = true;
      this.isEdit = false;
      this.roleForm = {
        name: null,
        displayName: null,
        normalizedName: null,
        description: null,
        grantedPermissions: []
      }
    },
    editRole() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要编辑的一行数据！');
      }
      let params = { Id: row.id };
      let that = this;
      GetRoleDetail(params).then((res) => {
        if (res.data.success) {
          that.roleForm = res.data.result;
          that.isEdit = true;
          that.roleFormVisible = true;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    delRole() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要删除的一行数据！');
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.tableLoading = true;
        let params = { Id: row.id };
        let that = this;
        DeleteRole(params).then((res) => {
          that.tableLoading = false;
          if (res.data.success) {
            that.$message.success('删除成功');
            that.getRoleList();
          } else {
            that.$message.error(res.data.msg);
          }
        });
      }).catch(() => { });
    },
    submitRole() {
      let that = this;
      that.$refs.roleForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            that.submitLoading = true;
            if (!that.isEdit) {
              CreateRole(that.roleForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('新增成功');
                  that.roleFormVisible = false;
                  that.getRoleList();
                } else {
                  that.$message.error(res.data.msg);
                }
              });
            } else {
              UpdateRole(that.roleForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('修改成功');
                  that.roleFormVisible = false;
                  that.getRoleList();
                } else {
                  that.$message.error(res.data.error.message);
                }
              });
            }
          }).catch(() => { });
        }
      });
    },
    getpermissionsList() {
      GetMenuTree().then((res) => {
        this.permissionsList = this.loopMenuTree([res.data.result])[0].children;
      });
    },
    // 递归封装菜单树
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        if (!item.data.Id) {
          item.id = 0 + '',
            item.label = '根节点'
        } else {
          item.id = item.data.Id + '';
          item.label = item.data.DisplayName;
        }
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    defaultChecked(menus) { // 默认选中
      this.$nextTick(() => {
        const arr = []
        menus.forEach(item => {
          if (!this.$refs.tree.getNode(item.name).childNodes || !this.$refs.tree.getNode(item.name).childNodes.length) {
            arr.push(item.name)
          }
        })
        this.$refs.tree.setCheckedKeys(arr)
      })
    },
    setPermissions() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择一行数据！');
      }
      let params = { id: row.id };
      let that = this;

      // GetRoleDetail(params).then((res) => {
      //   if (res.data.success) {
      //     that.roleForm = res.data.result;
      //     that.setPermissionsDialog = true;
      //     that.$nextTick(() => {
      //       that.setCheckedKeys(that.roleForm.grantedPermissions);
      //     });
      //   } else {
      //     that.$message.error(res.data.msg);
      //   }
      // });

      GetPermissions(params).then((res) => {
        if (res.data.success) {
          that.setPermissionsDialog = true;


          // let permissionList = [];
          // res.data.result.forEach(o => {
          //   permissionList.push((o.name));
          // })
          // that.$nextTick(() => {
          //   that.setCheckedKeys(permissionList);
          // });
          that.defaultChecked(res.data.result);

        } else {
          that.$message.error(res.data.msg);
        }
      });

    },
    submitPermissions() {
      this.$confirm("确认提交吗？", "提示", {
        closeOnClickModal: false,
      }).then(() => {

        let checkedNodes = this.$refs.tree.getCheckedNodes(false, true)
        let checkedIds = [];
        checkedNodes.forEach(o => {
          checkedIds.push((o.id));
        })

        let params = {
          roleId: this.currentRow.id,
          permissions: checkedIds
        };


        // let params = {
        //   roleId: this.currentRow.id,
        //   permissions: this.getCheckedKeys()
        // };
        let that = this;
        SetPermissions(params).then((res) => {
          that.submitLoading = false;
          if (res.data.success) {
            that.$message.success('提交成功');
            that.setPermissionsDialog = false;
          } else {
            that.$message.error(res.data.error.message)
          }
        });

        // this.roleForm.grantedPermissions = this.getCheckedKeys();
        // let that = this;
        // UpdateRole(that.roleForm).then((res) => {
        //   that.submitLoading = false;
        //   if (res.data.success) {
        //     that.$message.success('提交成功');
        //     that.setPermissionsDialog = false;
        //   } else {
        //     that.$message.error(res.data.error.message)
        //   }
        // });
      }).catch(() => { });
    },
    // 获取选中的key
    getCheckedKeys() {
      return this.$refs.tree.getCheckedKeys();
    },
    // 通过设置key选中节点
    setCheckedKeys(keyList) {
      this.$refs.tree.setCheckedKeys(keyList);
    }
  }
};
</script>
<style scoped>
#main-box {
  width: 100%;
  height: 100%;
  /* padding-top: 90px; */
}

/* 
#btn-box {
  position: fixed;
  height: 110px;
  top: 94px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
  padding-top: 5px;
} */

/* 
#btn-box /deep/ .el-form-item {
  margin-bottom: 10px;
} */

/* #main-box /deep/ .el-pagination {
  padding: 10px 5px;
} */
</style>
